import Button from 'components/Button'
import Flex from 'components/Flex'
import Group from 'components/Images/Group.png'
import { Heading, Para } from 'modules/Drives/ViewDrive/Style/style'
import React from 'react'

const AddRoundConformDrawer = ({
  setRoundConfromDrawer,
  itemsWithNoId,
  getDriveRoleMetrics,
  expcandidatesId,
  getDriveRoleCandidatesList,
  driveId,
  roleId,
  currentPage,
  stage,
  getRoleMetrics,
  isEditCondition,
  setIsEditCondition,
}) => {
  const onClose = async () => {
    setRoundConfromDrawer(false)
    getDriveRoleMetrics(expcandidatesId)
    await getDriveRoleCandidatesList({
      driveId: driveId,
      roleId: roleId,
      currentPage,
      stage,
    })
    getRoleMetrics(driveId, roleId)
    setIsEditCondition(false)
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        margin: '170px',
      }}
    >
      <Flex>
        <img src={Group} alt="driveIcon" />
      </Flex>
      <Flex
        column
        style={{
          marginTop: '10px',
        }}
      >
        {itemsWithNoId?.length && !isEditCondition ? (
          <>
            <Heading center>New Round Added Successfully</Heading>
            <Para>
              {itemsWithNoId[itemsWithNoId.length - 1].name} has been added
              successfully
            </Para>
          </>
        ) : (
          <Heading center>Updated Successfully</Heading>
        )}
      </Flex>
      <div
        style={{
          marginTop: '30px',
        }}
      >
        <Button.Secondary text="Close" height="38px" onClick={onClose} />
      </div>
    </div>
  )
}

export default AddRoundConformDrawer
